import React from "react";
import { useRouteMatch } from "react-router";
import { InputLabel } from "@material-ui/core";
import { KDatePicker, KButton } from "@kyburz/kdesign-system";
import useSafeSetState from "../../../../hooks/useSafeSetState";
import EventsList from "../../../../components/eventsList";
import { getTelemetryByDevice } from "../../../../apiCalls/config/devices";
import { useStyles } from "./styles";

const today = new Date();
const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);
const DeviceHistory = () => {
  const match = useRouteMatch({
    path: "/config/devices/device/:imei/history",
    strict: true,
    sensitive: true,
  });
  const { imei } = match?.params as any;
  const classes = useStyles();
  const [
    { startDate, endDate, startTime, endTime, events, loading },
    setState,
  ] = useSafeSetState({
    startDate: today,
    endDate: tomorrow,
    startTime: "00:00",
    endTime: "00:00",
    events: [],
    loading: false,
  });

  const onDateChange = (dates): void => {
    const [start, end] = dates;
    setState({ startDate: start, endDate: end });
  };

  const handleTimeChange = (e): void => {
    setState({ [e.target.name]: e.target.value });
  };

  const handleGetHistory = () => {
    setState({ loading: true });
    getTelemetryByDevice(
      imei,
      1,
      startDate.toISOString().slice(0, 10),
      endDate.toISOString().slice(0, 10),
      startTime,
      endTime,
    ).then((res) => {
      if (res && res.data) {
        setState({ events: res.data, loading: false });
      }
    });
  };

  return (
    <>
      <div className={classes.root}>
        <KDatePicker
          selected={startDate}
          onChange={onDateChange}
          selectsStart={true}
          label="Date Range"
          startDate={startDate}
          compact
          endDate={endDate}
        />
        <div className={classes.time}>
          <InputLabel classes={{ root: classes.title }}>From (UTC)</InputLabel>
          <input
            type="time"
            id="startTime"
            name="startTime"
            value={startTime}
            onChange={handleTimeChange}
            className={classes.timeInput}
          />
        </div>
        <div className={classes.time}>
          <InputLabel classes={{ root: classes.title }}>To (UTC)</InputLabel>
          <input
            type="time"
            id="endTime"
            name="endTime"
            value={endTime}
            onChange={handleTimeChange}
            className={classes.timeInput}
          />
        </div>
        <KButton
          children="Search History"
          onClick={handleGetHistory}
          style={{ marginLeft: 16 }}
        />
      </div>
      <EventsList
        imei={imei}
        from={{ date: startDate, time: startTime }}
        to={{ date: endDate, time: endTime }}
        initialEvents={events}
        loading={loading}
      />
    </>
  );
};

export default DeviceHistory;
